import { jsx as _jsx } from "react/jsx-runtime";
import { useRef } from 'react';
import { ColorOption } from './ColorOption';
import { Wrapper } from './ColorSelector.styles';
export const ColorSelector = ({ ariaLabel, isDisabled = false, name, onChange, options, value })=>{
    const enabledColorOptionRefs = useRef([]);
    const handleKeyDown = (event)=>{
        const options = enabledColorOptionRefs.current;
        const currentIndex = options.findIndex((option)=>value === option.value);
        let offset = 0;
        if (options.length === 0 || currentIndex < 0) {
            return;
        }
        switch(event.key){
            case 'ArrowUp':
            case 'ArrowLeft':
                {
                    offset = -1;
                    break;
                }
            case 'ArrowDown':
            case 'ArrowRight':
                {
                    offset = 1;
                    break;
                }
            default:
                {
                    break;
                }
        }
        if (offset) {
            const nextIndex = (options.length + currentIndex + offset) % options.length;
            const nextOption = options[nextIndex];
            event.preventDefault();
            nextOption.focus();
            onChange(nextOption.value);
        }
    };
    return /*#__PURE__*/ _jsx(Wrapper, {
        "aria-label": ariaLabel ?? undefined,
        children: options.map(({ color, isDisabled: isOptionDisabled, textContent })=>/*#__PURE__*/ _jsx(ColorOption, {
                color: color,
                isDisabled: isDisabled || isOptionDisabled,
                isSelected: color === value,
                name: name,
                onChange: onChange,
                onKeyDown: handleKeyDown,
                ref: (ref)=>{
                    if (ref && !isDisabled) {
                        enabledColorOptionRefs.current.push(ref);
                    }
                },
                textContent: textContent
            }, color))
    });
};

//# sourceMappingURL=ColorSelector.js.map